<template>
	<el-drawer :modal="false" :visible.sync="is_visible"
		:title="'Activity Log ' + _gHlp.getValue(activeCustomerInv, 'name')" class="drawer-activity-log" size="45%"
		@opened="initComponent()"
		@closed="hide()">
		<b-container>
			<!-- <b-row>
        <b-col cols="4">
          <b-form-group class="mb-0">
            <el-date-picker v-model="filters.date" type="date" placeholder="Filter by date">
            </el-date-picker>
          </b-form-group>
        </b-col>
      </b-row> -->
			<div class="table-listings">
				<el-table ref="ccrisTable" style="width: 100%" size="small" v-loading="is_loading" :data="tableData"
					:header-cell-class-name="'text-13px'">
					<el-table-column label="Activity" min-width="300" prop="messages" sortable>
						<template slot-scope="scope">
							<div @click="showDetail(scope.row)" style="cursor: pointer;">
								<p v-html="scope.row.messages"></p>
								<small><strong>Key:</strong> {{ (scope.row.log_key).replace('_id','') }} | <strong>Tags:</strong> {{ (scope.row.tags||'#').replace(/#/g,'') }}</small>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="Date" width="150" prop="created_at" sortable>
						<template slot-scope="scope">
							<span>{{ scope.row.created_at | dateFormatFromNow }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</b-container>
		<el-dialog :modal="false" title="Detail Log" :visible.sync="detailLog" width="40%" :close="hideDetail" :modal-append-to-body="false" :append-to-body="true">
			<div class="mb-3">
				<p v-html="_gHlp.getValue(selectedItem,'messages')"></p>
				<small><strong>Key:</strong> {{ (_gHlp.getValue(selectedItem,'log_key','_id')).replace('_id','') }} | <strong>Tags:</strong> {{ (_gHlp.getValue(selectedItem,'tags','#')).replace(/#/g,'') }}</small>
			</div>
			<b-table-simple bordered class="w-100">
				<b-thead>
					<b-tr>
						<b-th>Before</b-th>
						<b-th>After</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<td>
						<pre>{{ _gHlp.getValue(selectedItem,'old_data') }}</pre>
					</td>
					<td>
						<pre>{{ _gHlp.getValue(selectedItem,'new_data') }}</pre>
					</td>
				</b-tbody>
			</b-table-simple>
		</el-dialog>
	</el-drawer>
</template>
<script>
import { Drawer, Option, Dialog, Select, Table, TableColumn, DatePicker } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';

export default {
	props: ['tags','log_key'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Drawer.name]: Drawer,
		[Dialog.name]: Dialog,
		[Option.name]: Option,
		[Select.name]: Select,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			is_visible: false,
			detailLog: false,
			is_loading: false,
			tableData: [],
			selectedItem: {}
		}
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomerInv', 'activeLoanEC']),
	},
	methods: {
		...mapActions(useCustomerStore, ['getActivityLogList']),
		show() {
			this.is_visible = true;
		},
		hide() {
			this.is_visible = false;
		},
		initComponent() {
			this.is_loading = true;
			let params = {
				search: {}
			}

			if(!_gHlp.isEmpty(this.log_key)){
				params.search['log_key'] = this.log_key;
			}
			if(!_gHlp.isEmpty(this.tags)){
				params.search['tags'] = this.tags;
			}

			this.getActivityLogList(params).then(resp => {
				this.tableData = resp.data;
				this.is_loading = false;
			})
		},
		showDetail(item){
			this.selectedItem = item;
			this.detailLog = true
		},
		hideDetail(){
			this.detailLog = false;
			this.selectedItem = {};
		}
	}
}
</script>